import React, { useEffect, useMemo } from 'react';
import { Route, Routes } from 'react-router-dom';

import withTunnel from '../withTunnel';
import { Onboarding } from 'containers/tunnel';
import { stepIDs } from 'utils/constants';
import { useTunnelNavigation, useTunnelPhases } from 'utils/hooks';
import { blockDistributorNavigation } from 'utils/helpers';

const DistributorTunnel = props => {
    const {
        loggedIn,
        phaseMemo,
        internalUser,
        lastPhaseIndex,
        lastTunnelStepMemo,
        firstFailedUserStep,
        stepId,
        stepLoader,
        rolesLoader,
    } = props;

    const navigateToStep = useTunnelNavigation();
    const { phases, isLoading: tunnelListLoader } = useTunnelPhases();

    const dataIsLoading = useMemo(
        () => stepLoader || tunnelListLoader || rolesLoader,
        [stepLoader, tunnelListLoader, rolesLoader]
    );

    // distributor tunnel specific logic
    // this effect should redirect to the last accessible step if any irregularities:
    // - no stepId in URL
    // - stepId not found in list
    // - step with stepId not accessible
    useEffect(() => {
        if (dataIsLoading || !phases.length) return;
        let phaseIndex = phases.findIndex(ph => ph.tunnelSteps.find(ts => ts.step.id === stepId));
        const firstFailedTunnelStepIndex = phaseMemo?.tunnelSteps.findIndex(
            ts => ts.id === firstFailedUserStep?.tunnelStep.id
        );
        // current tunnelStep index by stepId from the URL
        const currentStepIndex = phaseMemo?.tunnelSteps.findIndex(ts => ts.step.id === stepId);
        const lastTunnelStepIdx = phases[lastPhaseIndex]?.tunnelSteps.findIndex(
            ts => ts.id === lastTunnelStepMemo?.id
        );

        if (blockDistributorNavigation(internalUser)) {
            navigateToStep(stepIDs.LAST_STEP_ONBOARDING);
        } else if (
            loggedIn &&
            (!stepId ||
                phaseIndex === -1 ||
                phaseIndex > lastPhaseIndex ||
                (currentStepIndex > lastTunnelStepIdx &&
                    lastTunnelStepIdx > -1 &&
                    phaseIndex === lastPhaseIndex) ||
                (currentStepIndex > firstFailedTunnelStepIndex &&
                    firstFailedTunnelStepIndex > -1 &&
                    currentStepIndex > -1))
        ) {
            let targetStepId = lastTunnelStepMemo?.step.id || stepId;
            navigateToStep(
                isNaN(targetStepId)
                    ? phases[lastPhaseIndex]?.tunnelSteps?.[0].step.id
                    : targetStepId
            );
        } else if (
            !loggedIn &&
            phaseMemo &&
            !phaseMemo.tunnelSteps.find(ts => ts.step.id === stepId)
        ) {
            navigateToStep(phases[0].tunnelSteps[0].step.id);
        }
    }, [
        dataIsLoading,
        phases,
        lastPhaseIndex,
        navigateToStep,
        stepId,
        phaseMemo,
        internalUser,
        loggedIn,
        lastTunnelStepMemo,
        firstFailedUserStep,
    ]);

    return (
        <Routes>
            <Route index element={<Onboarding {...props} />} />
            <Route path=":stepId" element={<Onboarding {...props} />} />
        </Routes>
    );
};

export default withTunnel(DistributorTunnel);
